import React from 'react';
import SubPage from '../SubPage';
import { useLang } from '../../LanguageContext';
import useSite from '../../useSite';

const CRUMB = { ko: '회사소개', en: 'About Us' };
const ADDR_Q = encodeURIComponent('경기도 안산시 상록구 안산대학로 117');
const KAKAO = `https://map.kakao.com/?q=${ADDR_Q}`;
const NAVER = `https://map.naver.com/p/search/${ADDR_Q}`;

const T = {
  title: { ko: '오시는길', en: 'Location' },
  lede:  { ko: '메디로지스를 찾아오시는 방법을 안내드립니다.', en: 'How to find us.' },
  h2:    { ko: '찾아오시는 곳', en: 'Visit Us' },
  mapAlt:{ ko: '메디로지스 위치 — 경기도 안산시 상록구 안산대학로 117',
           en: 'MEDILOGIS location — 117 Ansandaehak-ro, Sangnok-gu, Ansan-si, Gyeonggi-do' },
  kakao: { ko: '카카오맵 길찾기', en: 'Directions (Kakao Map)' },
  naver: { ko: '네이버지도 길찾기', en: 'Directions (Naver Map)' },
  rows: [
    { k: { ko: '주소',      en: 'Address' },
      v: { ko: '(15324) 경기도 안산시 상록구 안산대학로 117, 201호',
           en: '117 Ansandaehak-ro, Sangnok-gu, Ansan-si, Gyeonggi-do 15324, Room 201' } },
    { k: { ko: '전화',      en: 'Phone' },   v: { ko: '031-8042-7660', en: '+82-31-8042-7660' } },
    { k: { ko: '이메일',    en: 'Email' },   v: { ko: 'medilogis@medilogis.net', en: 'medilogis@medilogis.net' } },
    { k: { ko: '업무 시간', en: 'Hours' },
      v: { ko: '평일 09:00 – 18:00 (주말·공휴일 휴무)', en: 'Mon–Fri 09:00–18:00 (closed weekends and holidays)' } },
    { k: { ko: '유튜브',    en: 'YouTube' }, v: { ko: '메디로지스TV', en: 'MEDILOGIS TV' } },
  ],
};

const Pin = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M12 21s7-5.1 7-11a7 7 0 1 0-14 0c0 5.9 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

function Location() {
  const { lang } = useLang();
  // 주소·전화 등은 SITE_CONFIG 에서 관리한다
  const cfg = useSite('/api/site/config', null);
  const val = (key, fallback) => {
    if (!cfg || !cfg[key]) return fallback;
    return (lang === 'en' ? cfg[key].en : cfg[key].ko) || cfg[key].ko || fallback;
  };
  const KEYS = ['addr', 'tel', 'email', 'hours', 'youtube'];
  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <div className="sp-two">
        <div>
          {/* 지도 API 키가 필요 없도록 정적 이미지 + 외부 길찾기 링크로 처리 */}
          <a className="sp-map" href={KAKAO} target="_blank" rel="noopener noreferrer"
             aria-label={T.kakao[lang]}>
            <img src={process.env.PUBLIC_URL + '/images/map-ansan.jpg'} alt={T.mapAlt[lang]} />
          </a>
          <div className="sp-map-actions">
            <a className="sp-btn primary" href={KAKAO} target="_blank" rel="noopener noreferrer">
              <Pin /><span>{T.kakao[lang]}</span>
            </a>
            <a className="sp-btn ghost" href={NAVER} target="_blank" rel="noopener noreferrer">
              {T.naver[lang]}
            </a>
          </div>
        </div>
        <div>
          <div className="sp-label">CONTACT</div>
          <h2>{T.h2[lang]}</h2>
          <dl className="sp-rows">
            {T.rows.map((r, i) => (
              <div className="sp-row" key={i}>
                <dt>{r.k[lang]}</dt>
                <dd>{val(KEYS[i], r.v[lang])}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </SubPage>
  );
}

export default Location;
